export const STATUS_COLORS = {
  // GuaranteeApplication Statuses
  Auto: 'bg-primary-500',
  WaitProcessing: 'bg-warning-500',
  Processed: 'bg-success-500',
  Archived: 'bg-neutral-700',
  WillNotDo: 'bg-pink-900',

  // Prescription Statuses
  Guaranteed: 'bg-success-500',
  NotGuaranteed: 'bg-error-600',
  Planned: 'bg-primary-500',
  NotPlanned: 'bg-warning-500',
  Completed: 'bg-success-500',
  Confirmed: 'bg-success-500',
  Unknown: 'bg-warning-500',
  Failed: 'bg-error-600',
  PendingCreation: 'bg-warning-500',
  PendingReschedule: 'bg-warning-500',
  PendingCancellation: 'bg-warning-500',

  // Actions & Appointments Statuses
  ToDo: 'bg-warning-500',
  Done: 'bg-success-500',
  Rejected: 'bg-error-600',
  Created: 'bg-warning-500',
  Cancelled: 'bg-error-600',

  // New Appointments Statuses
  Scheduled: 'bg-primary-500',
  NoShow: 'bg-neutral-700',

  // Protocol Statuses
  Draft: 'bg-primary-500',
  Active: 'bg-success-500',

  // Recommendation Statuses
  Deactivated: 'bg-error-600',

  // Other
  Undefined: 'bg-neutral-200',
  Inactive: 'bg-neutral-200',
};
